import { useEffect, useState } from "react";
import { SITE } from "../data";

const headerNav = [
  { id: "about", label: "赛事简介" },
  { id: "play", label: "玩法流程" },
  { id: "rules", label: "赛制规则" },
  { id: "eligible", label: "参赛条件" },
  { id: "judge", label: "评选标准" },
  { id: "faq", label: "常见问题" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <a href="#home" className="flex items-center gap-2.5 shrink-0" aria-label="黑料大赛首页">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-emotion-laugh-line text-xl" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className={`font-casual text-lg md:text-xl ${solid ? "text-foreground-950" : "text-background-50"}`}>
              {SITE.brand}
            </span>
            <span className={`hidden sm:block text-[10px] tracking-widest mt-0.5 ${solid ? "text-foreground-500" : "text-background-200"}`}>
              SELF-ROAST CONTEST
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {headerNav.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`px-3.5 py-2 rounded-md text-sm transition-colors ${
                solid
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  : "text-background-100 hover:text-background-50 hover:bg-white/10"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#play"
            className="hidden sm:inline-flex items-center gap-1.5 px-4 md:px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors"
          >
            <i className="ri-play-circle-line" aria-hidden="true"></i>
            立即报名
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer transition-colors ${
              solid ? "text-foreground-950 bg-background-100" : "text-background-50 bg-white/10"
            }`}
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-3-line text-2xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <div
        className={`lg:hidden overflow-hidden transition-[max-height] duration-300 bg-background-50 border-t border-background-200 ${
          open ? "max-h-[70vh]" : "max-h-0"
        }`}
      >
        <nav className="px-4 py-3 flex flex-col" aria-label="移动端导航">
          {headerNav.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={() => setOpen(false)}
              className="py-3 border-b border-background-100 text-sm text-foreground-800 hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-3 py-3 text-center rounded-md bg-primary-500 text-background-50 text-sm font-medium"
          >
            联系我们
          </a>
        </nav>
      </div>
    </header>
  );
}